<template>
  <b-modal :visible="value" title="Crear Cliente" size="lg" @hidden="resetForm" @ok.prevent="submit" @show="onShow">
    <b-form ref="frmCliente" @submit.prevent="submit">
      <b-container>
        <b-row>
          <b-col>
            <b-form-group label="Unidad de negocio">
              <b-form-input readonly :value="unidadNegocio.razonSocial" />
            </b-form-group>

            <b-form-group label="Pais">
              <b-form-input readonly :value="pais.nombre" />
            </b-form-group>

            <b-form-group label="Nombre*">
              <b-form-input v-model="cliente.nombre" type="text" placeholder="Nombre del cliente" />
            </b-form-group>

            <b-form-group label="Sector*">
              <b-form-select v-model="cliente.clienteSectorId">
                <b-form-select-option disabled selected value=""> Selecciones el sector </b-form-select-option>
                <b-form-select-option v-for="sector in sectores" :key="sector.id" :value="sector.id">
                  {{ sector.nombreSector }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Contacto*">
              <b-form-input v-model="contacto.contacto" type="text" placeholder="Contacto del cliente" />
            </b-form-group>
            <b-form-group label="Cargo*">
              <b-form-input v-model="contacto.cargoContacto" type="text" placeholder="Cargo del contacto" />
            </b-form-group>
            <b-form-group label="Teléfono*">
              <b-form-input type="text" v-model="contacto.telefono" placeholder="Teléfono" />
            </b-form-group>
            <b-form-group label="Email*">
              <b-form-input type="email" v-model="contacto.email" placeholder="Email" />
            </b-form-group>
          </b-col>
          <input type="submit" class="hiddenSubmit" />
        </b-row>
      </b-container>
    </b-form>
  </b-modal>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    pais: {
      type: Object,
      required: true,
    },
    unidadNegocio: {
      type: Object,
      required: true,
    },
    sectores: {
      type: Array,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      cliente: {},
      contacto: {},
      contactos: [],
    };
  },
  computed: {},
  methods: {
    onShow() {},
    submit() {
      this.lanzarCreacion();
    },
    resetForm() {
      this.cliente = {};
      this.$emit("input", false);
    },
    lanzarCreacion() {
      if (!this.$refs.frmCliente.checkValidity()) {
        this.$refs.frmCliente.reportValidity();
        return;
      }

      this.contacto.default = true;
      Vue.set(this.contactos, this.contactos.length, this.contacto);
      const cliente = this.cliente;
      cliente.unidadNegocioId = this.unidadNegocio.id;
      cliente.paisId = this.pais.id;
      const contactos = this.contactos;

      this.$emit("crear", { cliente, contactos });
    },
  },
};
</script>
